import hyperdom from 'hyperdom'
import scroller from '../scroller.js'
import * as validation from '../validation.js'

export default class ValidationBase {
  fieldVisited (model, property) {
    this.validation = validation.fieldVisited(this.quoteCriteria, this.schema, model, property)
  }

  validate () {
    this.validation = validation.validate(this.quoteCriteria, this.schema)
    this.showValidationErrors = !this.validation.valid
    return this.validation
  }
  validateReferral () {
    this.validation = validation.validate(this.quoteCriteria, this.referralSchema)
    this.showValidationErrors = !this.validation.valid
    return this.validation
  }

  getFieldError (model, property) {
    if (this.showValidationErrors || (model._visited && model._visited.indexOf(property) != -1)) {
      return this.validation && this.validation.error(model, property)
    }
    return null
  }

  isFieldValid (model, property) {
    const error = this.getFieldError(model, property)
    return error !== null && !error
  }

  isFieldInvalid (model, property) {
    const error = this.getFieldError(model, property)
    return error !== null && error
  }

  renderValidationError (model, property, opts = {}) {
    const error = this.getFieldError(model, property)
    if (error) {
      const shouldScrollToError = this.hasScrolledToError ? undefined : scroller.scrollIntoView
      this.hasScrolledToError = true
      return <div class={`o-form-item__warning ${opts.cssClass || ''}`}>
        { shouldScrollToError ? shouldScrollToError(<div></div>, {behavior: 'smooth', block: 'center'}) : undefined }
        <div class="o-form-item__warning-icon">!</div>
        {hyperdom.rawHtml('span', error)}
      </div>
    }
  }

  resetScrolledToError () {
    this.hasScrolledToError = false
  }
}
